const IntegrationCardSkeleton = () => (
  <div className="animate-pulse text-left bg-white rounded-2xl border border-slate-100 shadow-sm overflow-hidden p-5">
    <div className="flex gap-4">
      {/* Icon placeholder */}
      <div className="size-12 rounded-md bg-gray-200 shrink-0" />

      <div className="flex-grow min-w-0 space-y-2">
        {/* Title */}
        <div className="h-4 bg-gray-200 rounded w-3/4" />
        {/* Type label */}
        <div className="h-3 bg-gray-100 rounded w-1/3" />

        {/* Status + app key row */}
        <div className="flex items-center gap-2 pt-0.5">
          <div className="h-5 w-14 bg-gray-200 rounded-full" />
          <div className="h-3 w-12 bg-gray-100 rounded" />
          <div className="h-5 w-20 bg-gray-100 rounded" />
        </div>

        {/* Tag chips */}
        <div className="flex gap-1.5 pt-0.5">
          <div className="h-6 w-20 bg-gray-100 rounded-md" />
          <div className="h-6 w-16 bg-gray-100 rounded-md" />
        </div>

        {/* Actions row */}
        <div className="flex justify-end gap-3 border-t border-slate-100 pt-3 mt-2">
          <div className="size-5 bg-gray-200 rounded" />
          <div className="size-5 bg-gray-200 rounded" />
          <div className="size-5 bg-gray-200 rounded" />
        </div>
      </div>
    </div>
  </div>
)

export default IntegrationCardSkeleton
